import canvasResource from "../resources/CanvasResource";
import { BaseRepository } from "../../../../infrastructure/BaseRepository";

class CanvasRepository extends BaseRepository {
  constructor() {
    super(canvasResource)
  }
}

const canvasRepository = new CanvasRepository();

export default canvasRepository;